import * as core from '../../../../../../../core'

import { query } from './traceability-matrix-orphaned.query'

export const RESOURCE = {
  payload: {
    alias: 'traceability-matrix.orphaned',
    description: 'Count of requirements with no linked pull request',
    name: 'Traceability Matrix - Orphaned',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
